module.exports = __webpack_public_path__ + "static/media/morepc.1e0a7bc5.png";